import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'app-calendar-mark-modal',
  templateUrl: './calendar-mark-modal.component.html',
  styleUrls: ['./calendar-mark-modal.component.scss']
})
export class CalendarMarkModalComponent implements OnInit {

  @Input() markData: any;

  @Output() closeModal: EventEmitter<null> = new EventEmitter();

  creator = true;
  confirmed = true;
  maybe = false;
  absent = false;
  noAnswer = false;

  isMobile: boolean;

    

  ngOnInit(): void {
    this.deviceWidth(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.deviceWidth(event.target.innerWidth);
  }

  deviceWidth(width: number): void {
    this.isMobile = width < 769;
  }

}
